import {TrueGrit} from "../../TrueGrit";
import {TrueGritOutroView} from "../base/TrueGritOutroView";
import {TrueGritGameAssets} from "../../TrueGritGameAssets";

/**
 * Created by Jerker Nord on 2021-09-25.
 */

export class TrueGritSuperFreeSpinOutroView extends TrueGritOutroView {

    constructor() {
        super();
        this.name = "TrueGritSuperFreeSpinOutroView";
    }

    protected getOutroContent():PIXI.Container {
        const container = new PIXI.Container();
        const bg = new PIXI.Sprite(TrueGrit.assetLoader.getTextures(TrueGritGameAssets.FS_OUTRO_BACKGROUND)[0]);
        bg.anchor.set(0.5,0.5);
        bg.position.set(360,360);


        const fsName = new PIXI.Sprite(TrueGrit.assetLoader.getTextures(TrueGritGameAssets.DEAD_SPINS_LOGO)[0]);
        fsName.anchor.set(0.5,0.5);
        fsName.position.set(360,175);

        const banner = new PIXI.Sprite(TrueGrit.assetLoader.getTextures(TrueGritGameAssets.DEAD_SPINS_OUTRO_BANNER)[0]);
        banner.anchor.set(0.5,0.5);
        banner.position.set(360,400);

        container.addChild(bg);
        container.addChild(fsName);
        container.addChild(banner);
        return container;
    }

}